module.exports = {"fireweb":{"apiKey":"af8ababb-0689-4837-b42d-081a9d90d872","secretKey":"7781f519d9ae5d4f9338d966e1563430"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/security.json
// module id = 576
// module chunks = 0